<template>
  <div>
    <h3 slot="title" class="title">Change Password</h3>
    <p v-if="tempPass" slot="subheader" class="subheader" style="color: red;">You are still using a temporary password, please change it</p>
    <p v-if="!tempPass" slot="subheader" class="subheader">Change your current password</p>

    <md-field slot="inputs" class="md-form-group" style="margin-top: 2rem;">
      <md-icon>mail_outline</md-icon>
      <label>Email</label>
      <md-input :disabled="true" v-model="username" type="email" />
    </md-field>

    <md-field slot="inputs" :class="[
        { 'md-valid': !errors.has('currentPassword') && touched.currentPassword },
        { 'md-form-group': true },
        { 'md-error': errors.has('currentPassword') && touched.currentPassword }
      ]"
    >
      <md-icon>lock_outline</md-icon>
      <label>Current Password</label>
      <md-input v-model="currentPassword" name="currentPassword" type="password" v-validate="psw1Validation" data-vv-name="currentPassword" />
    </md-field>

    <md-field slot="inputs" :class="[
        { 'md-valid': !errors.has('psw1') && touched.psw1 },
        { 'md-form-group': true },
        { 'md-error': errors.has('psw1') && touched.psw1 }
      ]"
    >
      <md-icon>lock_outline</md-icon>
      <label>New Password</label>
      <md-input v-model="psw1" name="password" type="password" v-validate="psw1Validation" ref="password" data-vv-name="psw1" />
    </md-field>

    <md-field slot="inputs" :class="[
        { 'md-valid': !errors.has('psw2') && touched.psw2 },
        { 'md-form-group': true },
        { 'md-error': errors.has('psw2') && touched.psw2 }
      ]">
      <md-icon>lock_outline</md-icon>
      <label>Re-enter Password</label>
      <md-input v-model="psw2" name="password_confirmation" type="password" v-validate="'required|confirmed:password'" data-vv-as="password" data-vv-name="psw2" />
    </md-field>

    <div style="text-align: right;margin-right: 4px;">
      <md-button slot="footer" class="md-primary" @click="changePassword"> Change Password </md-button>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2"
import { SlideYDownTransition } from "vue2-transitions"

export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      username: sessionStorage.getItem('username'),
      tempPass: true,
      isLoading: false,
      psw: null,
      currentPassword: null,
      psw1: null,
      psw2: null,
      status: null,
      touched: {
        currentPassword: false,
        psw1: false,
        psw2: false,
      },
      psw1Validation: {
        required: true,
        min: 5
      }
    }
  },
  mounted() {
    this.tempPass = sessionStorage.getItem("isTempPsw") === 'true';
  },
  methods: {
    changePassword() {
      this.touched.currentPassword = true;
      this.touched.psw1 = true;
      this.touched.psw2 = true;
      return this.$validator.validateAll().then(valid => {
        if (!valid) return;

        this.isLoading = true;
        this.psw = this.psw1

        const url = process.env.VUE_APP_URL + "/update-password/" + sessionStorage.getItem('username')
        const data = {
          currentPassword: this.currentPassword,
          newPassword: this.psw
        }
        const config = { headers: { "Content-Type": "application/json" } }

        var vm = this
        window.axios.post(url, data, config).then(response => {
          //POST MESSAGE to Member:
          const config_C = { headers: { "Content-Type": "application/json" } }
          const url_C = process.env.VUE_APP_URL + "/msg/newmessage"
          const data_C = {
            senderID: "Admin@GlobeChek.com",
            senderName: "GlobeChek Admin",
            recipientID: sessionStorage.getItem('userID'),
            recipientName: this.username,
            msg_subject: "PASSWORD RESET",
            msg_body: "Your GlobeChek password has successfully been reset. -  Thank You!",
            msg_level: "normal"
          }
          axios.post(url_C, data_C, config_C)
        })
        .then(() => {
          Swal.fire({
            title: "Success",
            text: "Your password was changed successfully",
            type: "success",
            confirmButtonClass: "md-button md-info",
            buttonsStyling: false,
            timer: 3000
          })
          this.tempPass = false;
          sessionStorage.removeItem("isTempPsw");
          this.currentPassword= null;
          this.psw1= null;
          this.psw2= null;
          this.touched.currentPassword= false;
          this.touched.psw1= false;
          this.touched.psw2= false;
        })
        .catch(errors => {
          console.log(errors);
          Swal.fire({
            title: "Error",
            text: "Current password is invalid. Please try again",
            type: "error",
            confirmButtonClass: "md-button md-info",
            buttonsStyling: false,
            timer: 3000
          })
          
        }).finally(()=>{
          this.isLoading = false;
        })
      })
    }
  }
}
</script>
